export const CONTRAT = {
  lecture: { module: 'baux', element: 'contrat', rule: 'lecture' },
  maj: { module: 'baux', element: 'contrat', rule: 'maj' },
  exporter: { module: 'baux', element: 'contrat', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'contrat', rule: 'supprimer' },
  editer: { module: 'baux', element: 'contrat', rule: 'edition' },
};

export const BAILLEUR = {
  lecture: { module: 'baux', element: 'bailleur', rule: 'lecture' },
  maj: { module: 'baux', element: 'bailleur', rule: 'maj' },
  exporter: { module: 'baux', element: 'bailleur', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'bailleur', rule: 'supprimer' },
};

export const CONSTATATION_CHARGE = {
  lecture: { module: 'baux', element: 'constatation_charge', rule: 'lecture' },
  maj: { module: 'baux', element: 'constatation_charge', rule: 'maj' },
  exporter: { module: 'baux', element: 'constatation_charge', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'constatation_charge', rule: 'supprimer' },
};

export const ECHEANCIER_CONTRAT = {
  lecture: { module: 'baux', element: 'echeancier_contrat', rule: 'lecture' },
  maj: { module: 'baux', element: 'echeancier_contrat', rule: 'maj' },
  exporter: { module: 'baux', element: 'echeancier_contrat', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'echeancier_contrat', rule: 'supprimer' },
};
export const JOURNAL_PAIEMENTS = {
  lecture: { module: 'baux', element: 'journal_paiements', rule: 'lecture' },
  maj: { module: 'baux', element: 'journal_paiements', rule: 'maj' },
  exporter: { module: 'baux', element: 'journal_paiements', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'journal_paiements', rule: 'supprimer' },
};

export const CONTRAT_NATURE = {
  lecture: { module: 'baux', element: 'contrat_nature', rule: 'lecture' },
  maj: { module: 'baux', element: 'contrat_nature', rule: 'maj' },
  exporter: { module: 'baux', element: 'contrat_nature', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'contrat_nature', rule: 'supprimer' },
};

export const CONTRAT_SIGNATAIRE = {
  lecture: { module: 'baux', element: 'signataire', rule: 'lecture' },
  maj: { module: 'baux', element: 'signataire', rule: 'maj' },
  exporter: { module: 'baux', element: 'signataire', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'signataire', rule: 'supprimer' },
};

export const LOT_PAIEMENT = {
  lecture: { module: 'baux', element: 'lot_paiement', rule: 'lecture' },
  maj: { module: 'baux', element: 'lot_paiement', rule: 'maj' },
  editer: { module: 'baux', element: 'lot_paiement', rule: 'edition' },
  exporter: { module: 'baux', element: 'lot_paiement', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'lot_paiement', rule: 'supprimer' },
};

export const FACTURE_ACHAT = {
  lecture: { module: 'baux', element: 'facture_achat', rule: 'lecture' },
  maj: { module: 'baux', element: 'facture_achat', rule: 'maj' },
  exporter: { module: 'baux', element: 'facture_achat', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'facture_achat', rule: 'supprimer' },
};

export const DEMARCHEUR = {
  lecture: { module: 'baux', element: 'demarcheur', rule: 'lecture' },
  maj: { module: 'baux', element: 'demarcheur', rule: 'maj' },
  exporter: { module: 'baux', element: 'demarcheur', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'demarcheur', rule: 'supprimer' },
};

export const INDICE_ET_VALEUR = {
  lecture: { module: 'baux', element: 'indice_et_valeur', rule: 'lecture' },
  maj: { module: 'baux', element: 'indice_et_valeur', rule: 'maj' },
  exporter: { module: 'baux', element: 'indice_et_valeur', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'indice_et_valeur', rule: 'supprimer' },
};
export const COMMANDE_ACHAT = {
  lecture: { module: 'baux', element: 'commande_achat', rule: 'lecture' },
  maj: { module: 'baux', element: 'commande_achat', rule: 'maj' },
  exporter: { module: 'baux', element: 'commande_achat', rule: 'exporter' },
  supprimer: { module: 'baux', element: 'commande_achat', rule: 'supprimer' },
  editer: { module: 'baux', element: 'commande_achat', rule: 'edition' },
};
